import { getRequest, formatDateInvariant } from "../util/util.js";

const categoryId = "search-category";
const searchInputId = "search-term";
const viewPageURLid = "view-page-url";
const viewBlogId = "view-blog-container";
const loadMoreBtnId = "load-more-btn";
const mainChannelSearchAPIEndpoint = "GetMainChannelContentFromSearch";
const mainChannelAllDataAPIEndpoint = "GetAllMainChannelContentData";
const mainChannelAllDataByCategoryAPIEndpoint = "GetAllMainChannelContentByCategory";


const selectCategory = document.getElementById(categoryId);
const searchInputElem = document.getElementById(searchInputId);
const blogContainer = document.getElementById(viewBlogId);
const viewPageUrl = document.getElementById(viewPageURLid);
const loadMoreBtn = document.getElementById(loadMoreBtnId);

/**
 * 
 * @param {("GetMainChannelContentFromSearch"|"GetAllMainChannelContentData")} apiEndPoint - API Endpoint to get results for category filter or searchTerm  
 * @param {("searchTerm"|"category")} query - query key name - searchTerm or category
 * @param {string} value - query value 
 * @param {number} skip - How many to skip
 * @param {number} take - How many to take
 * @returns {string} generated url for fetch api
 */
const queryGenerator = (apiEndPoint, query, value, skip = 0, take = 10) => {
    return `${location.origin}/umbraco/api/MainChannelAPI/${apiEndPoint}?${query}=${encodeURI(value)}&skip=${skip}&take=${take}`;
}

// determine if on view-page
const isViewPage = !!(viewPageUrl) && (viewPageUrl.dataset.current === viewPageUrl.value);

function searchRedirectToViewAllPage() {
    if (isViewPage) return;

    if (selectCategory) {
        selectCategory.addEventListener('change', () => {
            if (selectCategory.value != null && selectCategory.value != "") {
                // console.log(`${viewPageUrl.value}?category=${encodeURIComponent(selectCategory.value)}&skip=0&take=10`)
                location.href = `${viewPageUrl.value}?category=${encodeURIComponent(selectCategory.value)}`;
            }
        })
    }

    if (searchInputElem) {
        const searchBtn = searchInputElem.querySelector(`[role="button"]`);
        const inputElem = searchInputElem.querySelector(`[type="search"]`);
        // console.log("@CC searchBtn", searchBtn);
        // console.log("@CC input", inputElem);

        searchBtn.addEventListener('click', handleClickEvent);
        inputElem.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                handleClickEvent()
            }
        });

        function handleClickEvent() {
            /**@type {string} */
            const rawSearch = inputElem.value;
            if (rawSearch != null && rawSearch.trim() != "") {
                const searchTerm = rawSearch.normalize();
                // console.log(`${viewPageUrl.value}?searchTerm=${encodeURIComponent(searchTerm)}&skip=0&take=10`)
                location.href = `${viewPageUrl.value}?searchTerm=${encodeURIComponent(searchTerm)}`;
            }
        }
    }
}

searchRedirectToViewAllPage();

if (isViewPage) {
    initialLoad(); // Display blogs on initial load when redirected from landing-page

    if (selectCategory) {
        selectCategory.addEventListener('change', handleCategoryChangeEvent);
    }

    if (searchInputElem) {
        const searchBtn = searchInputElem.querySelector(`[role="button"]`);
        const inputElem = searchInputElem.querySelector(`[type="search"]`);
        // console.log("@CC searchBtn", searchBtn);
        // console.log("@CC input", inputElem);
        searchBtn.addEventListener('click', handleSearchEvent)
        inputElem.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                handleSearchEvent();
            }
        })
    }

    if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', handleLoadMoreEvent);
    }
}

async function initialLoad() {
    const qParams = new URLSearchParams(location.search);
    let apiEndPoint, query, value, queryURL;

    if (qParams.has("searchTerm") && qParams.get("searchTerm") != "") {
        apiEndPoint = mainChannelSearchAPIEndpoint;
        query = "searchTerm";
        value = qParams.get("searchTerm");
        queryURL = queryGenerator(mainChannelSearchAPIEndpoint, query, value);

        const response = await getRequest(queryURL);
        if ("totalCount" in response) {
            blogContainer.dataset.blogCount = response.totalCount;
            if (response?.totalCount <= 10) {
                loadMoreBtn?.setAttribute('disabled', true);
            }
        }

        if ("returnData" in response && response?.returnData.length > 0) {
            const data = response.returnData;

            const frag = document.createDocumentFragment();
            for (const item of data) {
                frag.appendChild(blogTeaserElem(item));
            }
            blogContainer.innerHTML = "";
            blogContainer.append(frag);
        }
        return; // when url has both searchTerm and category return on searchTerm
    }

    if (qParams.has("category") && qParams.get("category") != "") {
        apiEndPoint = mainChannelAllDataByCategoryAPIEndpoint;
        // apiEndPoint = "GetAllMainChannelContent";
        query = "category";
        value = qParams.get("category");
        queryURL = queryGenerator(apiEndPoint, query, value);

        const response = await getRequest(queryURL);
        if ("totalCount" in response) {
            blogContainer.dataset.blogCount = response.totalCount;
            if (response?.totalCount <= 10) {
                loadMoreBtn?.setAttribute('disabled', true);
            }
        }

        if ("returnData" in response && response?.returnData.length > 0) {
            const data = response.returnData;
            const frag = document.createDocumentFragment();
            for (const item of data) {
                frag.appendChild(blogTeaserElem(item));
            }
            blogContainer.innerHTML = "";
            blogContainer.append(frag);
        }
    }
}

/**
 * @param {Event} e 
 */
async function handleCategoryChangeEvent(e) {
    const inputElem = searchInputElem.querySelector(`[type="search"]`);
    const pageUrl = new URL(location.href);
    if (e.target.value == "") {
        const queryURL = `${location.origin}/umbraco/api/MainChannelAPI/${mainChannelAllDataAPIEndpoint}`
        const response = await getRequest(queryURL);
        // Empty search input 
        if (inputElem) { inputElem.value = ""; }
        if ("totalCount" in response) {
            blogContainer.dataset.blogCount = response.totalCount;
            if (response?.totalCount <= 10) {
                loadMoreBtn?.setAttribute('disabled', true);
            } else {
                loadMoreBtn?.removeAttribute('disabled');
            }
        }
        if ("returnData" in response && response?.returnData.length > 0) {
            // update page url
            pageUrl.search = "";
            window.history.pushState({}, "", pageUrl);
            // update display blogs
            const data = response.returnData;
            // console.log("@cc inside handleCategoryChange", { data })
            const frag = document.createDocumentFragment();
            for (const item of data) {
                frag.appendChild(blogTeaserElem(item));
            }
            blogContainer.innerHTML = "";
            blogContainer.append(frag);
        }
    }
    else if (e.target.value != "") {
        const apiEndPoint = mainChannelAllDataByCategoryAPIEndpoint;
        const query = "category";
        const value = e.target.value;
        const queryURL = queryGenerator(apiEndPoint, query, value);

        // Empty search input 
        if (inputElem) { inputElem.value = ""; }
        const response = await getRequest(queryURL);
        if ("totalCount" in response) {
            blogContainer.dataset.blogCount = response.totalCount;
            if (response?.totalCount <= 10) {
                loadMoreBtn?.setAttribute('disabled', true);
            } else {
                loadMoreBtn?.removeAttribute('disabled');
            }
        }
        if ("returnData" in response && response?.returnData.length > 0) {
            // update page url
            pageUrl.search = "";
            pageUrl.searchParams.set(query, value);
            window.history.pushState({}, "", pageUrl);
            // update display blogs
            const data = response.returnData;
            // console.log("@cc inside handleCategoryChange", { data })
            const frag = document.createDocumentFragment();
            for (const item of data) {
                frag.appendChild(blogTeaserElem(item));
            }
            blogContainer.innerHTML = "";
            blogContainer.append(frag);
        }
    }
}

/**
 * @param {Event} e 
 */
async function handleSearchEvent(e) {
    const inputElem = searchInputElem.querySelector(`[type="search"]`);
    const rawSearch = inputElem?.value;
    const pageUrl = new URL(location.href);
    if (rawSearch != null && rawSearch.trim() != "") {
        const apiEndPoint = mainChannelSearchAPIEndpoint;
        const query = "searchTerm";
        const value = rawSearch.normalize();
        const queryURL = queryGenerator(apiEndPoint, query, value);
        // Reset filter dropdown
        selectCategory.value = "";
        const response = await getRequest(queryURL);
        if ("totalCount" in response) {
            blogContainer.dataset.blogCount = response.totalCount;
            if (response?.totalCount <= 10) {
                loadMoreBtn?.setAttribute('disabled', true);
            } else {
                loadMoreBtn?.removeAttribute('disabled');
            }
        }
        if ("returnData" in response && response?.returnData.length > 0) {
            // update page url
            pageUrl.search = "";
            pageUrl.searchParams.set(query, value);
            window.history.pushState({}, "", pageUrl);
            // update display blogs
            const data = response.returnData;
            // console.log("@cc inside handleCategoryChange", { data })
            const frag = document.createDocumentFragment();
            for (const item of data) {
                frag.appendChild(blogTeaserElem(item));
            }
            blogContainer.innerHTML = "";
            blogContainer.append(frag);
        }
    } else if (rawSearch == "") {
        const queryURL = `${location.origin}/umbraco/api/MainChannelAPI/${mainChannelAllDataAPIEndpoint}`
        const response = await getRequest(queryURL);
        // Empty search input 
        selectCategory.value = "";
        if ("totalCount" in response) {
            blogContainer.dataset.blogCount = response.totalCount;
            if (response?.totalCount <= 10) {
                loadMoreBtn?.setAttribute('disabled', true);
            } else {
                loadMoreBtn?.removeAttribute('disabled');
            }
        }
        if ("returnData" in response && response?.returnData.length > 0) {
            // update page url
            pageUrl.search = "";
            window.history.pushState({}, "", pageUrl);
            // update display blogs
            const data = response.returnData;
            // console.log("@cc inside handleCategoryChange", { data })
            const frag = document.createDocumentFragment();
            for (const item of data) {
                frag.appendChild(blogTeaserElem(item));
            }
            blogContainer.innerHTML = "";
            blogContainer.append(frag);
        }
    }
}

///**
// * @typedef {Object} ImageUrlObject
// * @property {number} id
// * @property {(string|number)} height  
// * @property {(string|number)} width
// * @property { URL} url - url of image
// * @property {string} altText
// * 
// * @typedef {Object} IItem
// * @property { number } id
// * @property {string} category     
// * @property {string} title - Page Title
// * @property {string} description - Short teaser description
// * @property {boolean} isFeatured
// * @property {ImageUrlObject} desktopImage - Image
// * @property {ImageUrlObject} mobileImage 
// */

/**    
 * @param {IItem} item - Input from api
 * @returns {HTMLAnchorElement} - Returns Card elem for displaying.
 */
function blogTeaserElem(item) {
    const { category, title, description, pageURL = "", desktopImageCropper, mobileImageCropper, updatedDate, isFeatured } = item;
    const anchor = document.createElement("a");
    anchor.href = pageURL;
    anchor.setAttribute("title", title);
    console.log(item);

    const featuredTag = isFeatured ?
        `<span class="text-base/snug absolute left-2 top-2 rounded bg-white px-8 py-2 text-[#707070]">Featured</span>`
        : "";
    console.log(featuredTag);

    const articleHtml = `<article class="relative theme-dark rounded">
  <picture>
    <source srcset="${mobileImageCropper}" media="(max-width:800px)" width="375" height="375" />
    <img class="w-full rounded" src="${desktopImageCropper}" width="800" height="600" />
  </picture>
   ${featuredTag}
  <div class="absolute inset-4 lg:inset-8 inline-flex flex-col justify-end blogs-start">
    <div>
      <div>
      	<p class="text-sm italic">${formatDateInvariant(updatedDate)}</p>
        <span class="uppercase">${category}</span>
        <h4>${title}</h4>
        <p>${description}</p>
      </div>
    </div>
  </div>
</article>`
    anchor.innerHTML = articleHtml.trim();
    return anchor;
}

async function handleLoadMoreEvent() {
    const blogContainer = document.getElementById(viewBlogId);
    const qParams = new URLSearchParams(location.search);
    let apiEndPoint, query, value, queryURL;
    const { blogCount = 0 } = blogContainer?.dataset;
    const displayBlogCount = blogContainer?.childElementCount ?? 0;
    // console.log(blogCount,displayBlogCount , "Condition" , blogCount<=displayBlogCount)
    if (blogCount <= displayBlogCount) {
        loadMoreBtn.setAttribute('disabled', true);
        return;
    }
    let skip = displayBlogCount;

    if (qParams.size == 0) {
        queryURL = `${location.origin}/umbraco/api/MainChannelAPI/${mainChannelAllDataAPIEndpoint}?skip=${skip}`
        const response = await getRequest(queryURL);
        if ("returnData" in response && response?.returnData.length > 0) {
            const data = response.returnData;

            const frag = document.createDocumentFragment();
            for (const item of data) {
                frag.appendChild(blogTeaserElem(item));
            }
            blogContainer.append(frag);
            if (blogCount <= blogContainer.childElementCount) {
                loadMoreBtn.setAttribute('disabled', true);
            }
        }
        return; // Early return when empty query param
    }

    if (qParams.has("searchTerm") && qParams.get("searchTerm") != "") {
        apiEndPoint = mainChannelSearchAPIEndpoint;
        query = "searchTerm";
        value = qParams.get("searchTerm");
        queryURL = queryGenerator(apiEndPoint, query, value, skip);

        const response = await getRequest(queryURL)

        if ("returnData" in response && response?.returnData.length > 0) {
            const data = response.returnData;

            const frag = document.createDocumentFragment();
            for (const item of data) {
                frag.appendChild(blogTeaserElem(item));
            }
            blogContainer.append(frag);
            if (blogCount <= blogContainer.childElementCount) {
                loadMoreBtn.setAttribute('disabled', true);
            }
        }
        return; // When query has both searchterm and category early return;
    }

    if (qParams.has("category") && qParams.get("category") != "") {
        apiEndPoint = mainChannelAllDataByCategoryAPIEndpoint;
        query = "category";
        value = qParams.get("category");
        queryURL = queryGenerator(apiEndPoint, query, value, skip);

        const response = await getRequest(queryURL);

        if ("returnData" in response && response?.returnData.length > 0) {
            const data = response.returnData;

            const frag = document.createDocumentFragment();
            for (const item of data) {
                frag.appendChild(blogTeaserElem(item));
            }

            blogContainer.append(frag);
            if (blogCount <= blogContainer.childElementCount) {
                loadMoreBtn.setAttribute('disabled', true);
            }
        }
    }
}